export default __webpack_public_path__ + "static/media/crt-20-anos-w.df0a3ca6.svg";